
import MessagesTable from '@/views/_messages/components/MessagesTable.vue';
import { defineComponent } from 'vue';

export default defineComponent({
	components: {
		MessagesTable
	},
	created() {
		this.$store.commit('messages/SET_MESSAGE_TYPE', 'ALL');
		this.$store.commit('messages/SET_FILTER_RECIPIENT', this.$route.params.recipient);
	}
});
